import { Col, Modal, Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import { getNumberWithCommas } from '~/utils';
import RequireLoginModal from '../FormInputPhone';
import styles from './ItemService.module.scss';
import { useSelector } from 'react-redux';

const cx = classNames.bind(styles);

const ItemService = ({ data, ...props }) => {
    const navigate = useNavigate();

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');
    const [isShowInputPhone, setIsShowInputPhone] = useState(false);

    const [filter, setFiler] = useState({});

    const handleNavigateDetailService = () => {
        navigate(`/dich-vu-chi-tiet/${data.id}`);
        localStorage.setItem('branch_id', props?.filterBranch);
        localStorage.setItem('filterBack', JSON.stringify(filter));
    };
    const handleNavigateBookingService = () => {
        if (isLogin) {
            navigate(`/dat-lich/${data.id}`);
            localStorage.setItem('branch_id', props?.filterBranch);
            localStorage.setItem('filterBack', JSON.stringify(filter));
        } else {
            setIsShowInputPhone(true);
        }
    };

    const onRejectInputPhone = () => {
        setIsShowInputPhone(false);
    };
    const onAgreeInputPhone = () => {
        setIsShowInputPhone(false);
        navigate(`/dat-lich/${data.id}`);
        localStorage.setItem('branch_id', props?.filterBranch);
        localStorage.setItem('filterBack', JSON.stringify(filter));
    };

    useEffect(() => {
        const filter = {
            isBackFilter: props?.isBackFilter || false,
            keySearch: props?.keySearch || '',
            rangePrice: props?.rangePrice || {},
            filterOrder: props?.filterOrder || {},
        };
        setFiler(filter);
    }, [props]);

    return (
        <>
            <div className={cx('service_item_desktop')}>
                <Row justify="center">
                    <div className={cx('service_image')} onClick={handleNavigateDetailService}>
                        <img
                            src={data.image || IMAGES.ImagePlaceholder}
                            alt=""
                            style={{ objectFit: data.image ? 'cover' : 'contain' }}
                        />
                    </div>
                </Row>
                <div className={cx('service_container')}>
                    <Row justify="center" className={cx('name_service')} onClick={handleNavigateDetailService}>
                        {data.title}
                    </Row>
                    <Row justify="center" className={cx('time_service')}>
                        Time:  <span>{data.execution_time} minutes</span>
                    </Row>
                    <Row justify="center" align="middle" className={cx('price')}>
                        <span className={cx('price_sale')}>
                            {getNumberWithCommas(data.price - data.discount)}&nbsp;
                            {data?.unit_id ? `d/${data?.unit?.value}` : 'd'}
                        </span>
                        {parseInt(data?.discount) ? (
                            <>
                                <span className={cx('price_origin')}>
                                    {getNumberWithCommas(data.price)}&nbsp;
                                    {data?.unit_id ? `d/${data?.unit?.value}` : 'd'}
                                </span>
                                {Math.round((data.discount * 100) / data.price) ? (
                                    <span className={cx('discount')}>
                                        -{Math.round((data.discount * 100) / data.price)}%
                                    </span>
                                ) : null}
                            </>
                        ) : null}
                    </Row>
                    <Row justify="center" className={cx('summary')}>
                        {data.description}
                    </Row>
                    <Row justify="center" style={{ marginTop: '20px' }}>
                        <div className={cx('button')} onClick={handleNavigateBookingService}>
                            Book now
                        </div>
                    </Row>
                </div>
            </div>
            <Row className={cx('service_item_mobile')}>
                <Col xs={6}>
                    <Row>
                        <div className={cx('service_image')} onClick={handleNavigateDetailService}>
                            <img
                                src={data.image || IMAGES.ImagePlaceholder}
                                alt=""
                                style={{ objectFit: data.image ? 'cover' : 'contain' }}
                            />
                        </div>
                    </Row>
                </Col>
                <Col xs={18}>
                    <div className={cx('service_container')}>
                        <Row justify="center" className={cx('name_service')} onClick={handleNavigateDetailService}>
                            {data.title}
                        </Row>
                        <Row align="middle" className={cx('second_line')}>
                            <Col xs={14}>
                                <Row className={cx('price_sale')}>
                                    {getNumberWithCommas(data.price - data.discount)}&nbsp;
                                    {data?.unit_id ? `d/${data?.unit?.value}` : 'd'}
                                </Row>
                            </Col>
                            <Col xs={10}>
                                <Row justify="end" className={cx('time_service')}>
                                    <img src={SVGS.IconClock} alt="" />
                                    {data.execution_time}  <span>minutes</span>
                                </Row>
                            </Col>
                        </Row>
                        {data.discount > 0 && (
                            <Row align="middle" className={cx('final_line')}>
                                <div className={cx('price_origin')}>
                                    <del>
                                        {getNumberWithCommas(data.price)} &nbsp;
                                        {data?.unit_id ? `d/${data?.unit?.value}` : 'd'}
                                    </del>
                                </div>

                                <div className={cx('discount')}>-{Math.round((data.discount * 100) / data.price)}%</div>
                            </Row>
                        )}
                    </div>
                </Col>
            </Row>
            {isShowInputPhone && (
                <Modal
                    centered
                    visible={isShowInputPhone}
                    onCancel={onRejectInputPhone}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={550}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <RequireLoginModal onAgreeInputPhone={onAgreeInputPhone} />
                    </div>
                </Modal>
            )}
        </>
    );
};

export default ItemService;
